import React, { useContext, useMemo } from "react";
import { FabekeDropdown } from "./FabekeDropdown";
import { useTextDomainContext } from "@/app/providers";
import { AutocompleteDropdown } from "./AutocompleteDropdown";
import { SimpleDropdown } from "./SimpleDropdown";
import { languageList } from "@/utils";

interface LanguageDropdownCommonProps {
  componentLabel?: string;
  defaultValue?: string;
  onChange?: (_event: any) => void;
  required?: boolean;
  visualStyle: "autoComplete" | "autoCompleteMulti" | "simple" | "old";
}

/**
 * Language dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export function LanguageDropdownCommon(props: LanguageDropdownCommonProps) {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = languageList(gettext);

  //#region useMemo
  const dropdownProps = useMemo(() => {
    const ddProps: any = {
      options,
      componentLabel: gettext("Languages"),
      defaultValue: "",
      visualStyle: "autoComplete",
      size: "small",
    };

    if (props.componentLabel) {
      ddProps.componentLabel = props.componentLabel;
    }

    if (props.defaultValue) {
      ddProps.defaultValue = props.defaultValue;
    }

    if (props.required) {
      ddProps.required = props.required;
    }

    return ddProps;
  }, [
    gettext,
    options,
    props.componentLabel,
    props.defaultValue,
    props.required,
  ]);
  //#endregion useMemo

  //#region Handlers
  /**
   * Handles change event of the language dropdown
   * @param {object} event event object
   * @returns {void}
   */
  const handleChange = (_event: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(_event);
    }
  };
  //#endregion Handlers

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {props.visualStyle === "old" && (
        <FabekeDropdown onChange={handleChange} {...dropdownProps} />
      )}
    </>
  );
}
